/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentences`)
};

const es_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oraciones`)
};

const de_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze`)
};

const nl_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zinnen`)
};

const fr_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrases`)
};

const it_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frasi`)
};

const pt_br2_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frases`)
};

const pt_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frases`)
};

const ja_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文`)
};

const zh_li_type_sentences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`句子`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_type_sentences = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_type_sentences(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_type_sentences", locale)
	if (locale === "en") return en_li_type_sentences(inputs)
	if (locale === "es") return es_li_type_sentences(inputs)
	if (locale === "de") return de_li_type_sentences(inputs)
	if (locale === "nl") return nl_li_type_sentences(inputs)
	if (locale === "fr") return fr_li_type_sentences(inputs)
	if (locale === "it") return it_li_type_sentences(inputs)
	if (locale === "pt-BR") return pt_br2_li_type_sentences(inputs)
	if (locale === "pt") return pt_li_type_sentences(inputs)
	if (locale === "ja") return ja_li_type_sentences(inputs)
	return zh_li_type_sentences(inputs)
};